import { NONEDITABLE_COMPONENTS } from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/component-constants';
import {
  isCurrentComponentBIPASubmitTrigger,
  isCurrentComponentBIPAText,
} from 'dashboard/apps/InquiryTemplateEditor/InquiryTemplateScreenComponentEditor/utils';
import { InquiryTemplateVersionStepUi } from 'dashboard/models/inquiry-template-version';
import {
  isTextComponent,
  isTextComponentConfig,
  UiComponent,
  UiComponentConfig,
} from 'lib/interfaces/ui-components';

interface ShouldEnableInlineTextEdits {
  componentPreview?: UiComponent;
  componentConfig?: UiComponentConfig;
  stepConfig: InquiryTemplateVersionStepUi;
  useInlineTextEditor: boolean;
}

export const shouldEnableInlineTextEdits = ({
  componentPreview,
  componentConfig,
  stepConfig,
  useInlineTextEditor,
}: ShouldEnableInlineTextEdits) => {
  return (
    useInlineTextEditor &&
    isTextComponent(componentPreview) &&
    isTextComponentConfig(componentConfig) &&
    !isCurrentComponentBIPASubmitTrigger({ step: stepConfig, component: componentConfig }) &&
    !isCurrentComponentBIPAText({ step: stepConfig, component: componentConfig }) &&
    componentConfig != null &&
    !NONEDITABLE_COMPONENTS.includes(componentConfig.type)
  );
};
